import { useMutation } from "@tanstack/react-query";
import moment from "moment";
import { classNames as cx } from "primereact/utils";
import { requests } from "../../../../../../services/http-common";
import { If } from "../../../../../If/If";
import classes from "./NotificationItem.module.scss";
import { useToast } from "../../../../../../Providers/ToastProvider";
import { EmployeeRoles } from "../../../../../../models/Employee";
import { useUser } from "../../../../../../keycloak";

type NotificationItemProps = {
  id: number;
  title: string;
  shortText: string;
  description: string;
  hasSeen: boolean;
  createdAt: string;
  redirectUrl?: string;
  refetchNotifications: () => void;
};

const getPassedDays = (date: string): string => {
  const currentDate = moment();
  const creationDate = moment(new Date(date));

  const passedDays = currentDate.diff(creationDate, "days");
  if (passedDays === 0) {
    return "Today";
  }
  if (passedDays < 7) {
    return `${passedDays} days ago`;
  }

  return creationDate.format("DD/MM/YYYY");
};

export const NotificationItem = ({
  id: notificationId,
  title,
  hasSeen,
  shortText,
  description,
  createdAt,
  redirectUrl,
  refetchNotifications,
}: NotificationItemProps) => {
  const { show } = useToast();

  const user: any = useUser();

  const editNotificationRequest = useMutation({
    mutationFn: (notificationId: number) => {
      return requests.put(`/notification/${notificationId}`, {
        hasSeen: true,
      });
    },
    onSuccess: () => {
      refetchNotifications();
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response?.data?.error?.message || "Something went wrong ",
      });
    },
  });

  const handleNotifClick = () => {
    editNotificationRequest.mutate(notificationId);
    if (redirectUrl && user?.role === EmployeeRoles.HR_MANAGER) {
      window.open(
        `${process.env.REACT_APP_DSC_SERVICE_DOMAIN}/${redirectUrl}`,
        "_blank"
      );
    }
  };

  return (
    <div
      className={cx(classes.container, { [classes.notSeen]: !hasSeen })}
      onClick={handleNotifClick}
    >
      <div className={classes.icon}>
        <i className="pi pi-exclamation-circle"></i>
      </div>
      <div className={classes.content}>
        <div className={classes.title}>{title}</div>
        <div className={classes.text}>{shortText}</div>
        <div className={classes.date}>{getPassedDays(createdAt)}</div>
      </div>
      <div className={cx(classes.badge, { [classes.hasSeen]: hasSeen })}></div>
    </div>
  );
};
